import * as React from "react";

function SvgIcons8Idea(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M6.813 2.406L5.405 3.812 7.5 5.906 8.906 4.5zm18.375 0L23.093 4.5 24.5 5.906l2.094-2.093zM16 3.031a9.677 9.677 0 00-1 .063h-.031c-4.055.465-7.281 3.742-7.844 7.781-.45 3.25.89 6.195 3.125 8.094A5.243 5.243 0 0112 22v6h2.281c.348.598.98 1 1.719 1 .738 0 1.371-.402 1.719-1H20v-4h.094v-1.188c0-1.464.761-2.945 2-4.093C23.75 17.062 25 14.707 25 12c0-4.941-4.066-9.016-9-8.969zm0 2c3.863-.054 7 3.11 7 6.969 0 2.094-.969 3.938-2.313 5.281l.032.032c-1.344 1.253-2.203 2.894-2.438 4.687h-4.375c-.219-1.715-.957-3.371-2.344-4.563-1.765-1.503-2.82-3.761-2.468-6.312.437-3.152 2.992-5.684 6.125-6.031.261-.032.523-.059.781-.063zM2 12v2h3v-2zm25 0v2h3v-2zM7.5 20.094l-2.094 2.093 1.407 1.407L8.905 21.5zm17 0L23.094 21.5l2.093 2.094 1.407-1.407zM14 24h4v2h-4z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Idea);
